import StandProductsTable from "./stand-products-table";

export default StandProductsTable;
